import src from "IMAGE";
export default { src, width: 83, height: 83, blurWidth: 0, blurHeight: 0};
